import ProjectList from "views/project/ProjectList.js";
import TestcaseInfo from "views/project/TestcaseInfo.js";
import Login from "views/user/Login.js";
import SignUp from "views/user/SignUp.js";
import Main from "views/project/MainPage.js";
import People from "views/manager/People.js";
import ManagementPage from "views/manager/ManagementPage.js";

import APSMainPage from "views/aps/APSMainPage.js";
import APSDataUpload from "views/aps/APSDataUpload.js";

// @material-ui/icons
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import TimelineIcon from '@material-ui/icons/Timeline'
import DvrIcon from '@material-ui/icons/Dvr'

var dashRoutes = [
  {
    redirect: true,
    path: "/login",
    name: "",
    component: Login,
    layout: "/user"
  },
  {
    redirect: true,
    path: "/signup",
    name: "",
    component: SignUp,
    layout: "/user"
  },
  {
    path: "/main",
    menu: "/project",
    name: "프로젝트",
    component: Main,
    icon: TimelineIcon,
    layout: "/project"
  },
  {
    redirect: true,
    path: "/list",
    name: "프로젝트 목록",
    component: ProjectList,
    layout: "/project"
  },
  {
    redirect: true,
    path: "/testcase/info",
    menu: "/project/",
    name: "시나리오 정보",
    component: TestcaseInfo,
    layout: "/project"
  },
  {
    path: "/work",
    menu: "/aps",
    name: "APS",
    component: APSMainPage,
    icon: DvrIcon,
    layout: "/aps"
  },
  {
    redirect: true,
    path: "/info",
    name: "APS 데이터 입력",
    component: APSDataUpload,
    layout: "/aps"
  },
  {
    collapse: true,
    path: "/admin",
    name: "관리자 메뉴",
    icon: FolderSharedIcon,
    isAdmin: true,
    views: [
      {
        path: "/list",
        name: "고객사 관리", // 관리자가 프로젝트 추가/삭제
        icon: CreateNewFolderIcon,
        component: ManagementPage,
        menu: "admin",
        state: "multiCollapse",
        layout: "/admin"
      },
      {
        path: "/",
        name: "비밀번호 변경",
        icon: SupervisorAccountIcon,
        component: People,
        menu: "people",
        state: "multiCollapse",
        layout: "/people"
      }
    ]
  },
];
export default dashRoutes;
